import { useState, useEffect } from 'react'
import { useNotification } from '@orbitalgaming/games-frontend-library'
import { defaultContext } from './defaultContext'
import { sendMessages } from '../socket/sendMessages'

import {
  handleRollUnderHelper,
  handleStakeHelper,
  handleSliderValueHelper,
  handleConfigHelper,
  handleManualConfigsHelper,
  handleBaseStakeHelper,
} from './helpers'
import { useReceiveMessages } from '../socket/receiveMessages'

export default function useContextUpdate(
  socket: any,
  // setStakesForSocket: any,
  // setSocketaudio: any,
  name: any,
) {
  const [context, setContext] = useState(defaultContext)
  const [notification, handleNotification, notificationfadeOut] =
    useNotification()

  const { globalSocketMessages, diceSocketMessages } = new sendMessages(socket)

  useEffect(() => {
    setContext((ctx: any) => {
      return {
        ...ctx,
        handleStake,
        handleBaseStake,
        handleRollUnderValue,
        handleSliderValueCTX,
        handleAutoConfigCTX,
        handleManualConfigs,
        handleNotification,
        notification,
        isError,
        globalSocketMessages,
        diceSocketMessages,
        handleErrorText,
      }
    })
  }, [])

  useEffect(() => {
    setTimeout(() => {
      setContext(ctx => {
        return {
          ...ctx,
          notification,
          notificationfadeOut,
        }
      })
    }, 200)
  }, [notificationfadeOut, notification])

  const handleManualConfigs = (manualConfigs: any) => {
    handleManualConfigsHelper(manualConfigs, setContext)
  }

  const handleStake = (stake: string) => {
    handleStakeHelper(stake, setContext)
  }

  const handleBaseStake = (stake: string) =>
    handleBaseStakeHelper(stake, setContext)

  const handleRollUnderValue = (rollUnder: string) => {
    handleRollUnderHelper(rollUnder, setContext)
  }

  const handleSliderValueCTX = (sliderValue: string) =>
    handleSliderValueHelper(sliderValue, setContext)

  const [errorText, setErrorText] = useState<string>('')
  const [errorCode, setErrorCode] = useState<number>(0)
  const [isError, setIsError] = useState<boolean>(false)

  useEffect(() => {
    setContext(ctx => {
      return { ...ctx, errorText }
    })
  }, [errorText])
  useEffect(() => {
    setContext(ctx => {
      return { ...ctx, isError }
    })
  }, [isError])

  const handleErrorText = (text: string) => {
    setErrorText(errorText => (errorText ? errorText : text))
    setIsError(true)
  }

  const handleAutoConfigCTX = (configs: any, name: string) => {
    handleConfigHelper(configs, name, setContext)
  }

  const receiveMessage = useReceiveMessages({
    setContext,
    handleErrorText,
    handleNotification,
    setErrorCode,
  })

  return {
    context,
    // sender,
    // sendSocketMessage,
    receiveMessage,
    // setStatus,
    history,
    errorCode,
    errorText,
    handleErrorText
  }
}
